import { DEFAULT_LOCALE } from '@/lib/i18n/config'
import { numberFormat } from '@/lib/i18n/format'
import type { BillingPriceSummary } from './types'

const DEFAULT_PRICE_SUMMARY_CONFIG = {
  starter: { amountCents: 4900, currency: 'USD' },
  growth: { amountCents: 9900, currency: 'USD' },
  pro: { amountCents: 24_900, currency: 'USD' },
} as const

/** `$99`, `$49.50` (the fraction only when there is one), in `locale`. */
export function formatCurrency(args: {
  amount: number
  currency: string
  locale: string
}): string {
  return numberFormat(args.locale, {
    style: 'currency',
    currency: args.currency.toUpperCase(),
    maximumFractionDigits: args.amount % 1 === 0 ? 0 : 2,
  }).format(args.amount)
}

export function emptyPriceSummary(): BillingPriceSummary {
  return {
    starter: null,
    growth: null,
    pro: null,
  }
}

/** The list prices, labelled in English: a reader formats `amount` + `currency`. */
export function defaultPriceSummary(): BillingPriceSummary {
  return {
    starter: {
      amount: DEFAULT_PRICE_SUMMARY_CONFIG.starter.amountCents / 100,
      amountCents: DEFAULT_PRICE_SUMMARY_CONFIG.starter.amountCents,
      currency: DEFAULT_PRICE_SUMMARY_CONFIG.starter.currency,
      label: formatCurrency({
        amount: DEFAULT_PRICE_SUMMARY_CONFIG.starter.amountCents / 100,
        currency: DEFAULT_PRICE_SUMMARY_CONFIG.starter.currency,
        locale: DEFAULT_LOCALE,
      }),
    },
    growth: {
      amount: DEFAULT_PRICE_SUMMARY_CONFIG.growth.amountCents / 100,
      amountCents: DEFAULT_PRICE_SUMMARY_CONFIG.growth.amountCents,
      currency: DEFAULT_PRICE_SUMMARY_CONFIG.growth.currency,
      label: formatCurrency({
        amount: DEFAULT_PRICE_SUMMARY_CONFIG.growth.amountCents / 100,
        currency: DEFAULT_PRICE_SUMMARY_CONFIG.growth.currency,
        locale: DEFAULT_LOCALE,
      }),
    },
    pro: {
      amount: DEFAULT_PRICE_SUMMARY_CONFIG.pro.amountCents / 100,
      amountCents: DEFAULT_PRICE_SUMMARY_CONFIG.pro.amountCents,
      currency: DEFAULT_PRICE_SUMMARY_CONFIG.pro.currency,
      label: formatCurrency({
        amount: DEFAULT_PRICE_SUMMARY_CONFIG.pro.amountCents / 100,
        currency: DEFAULT_PRICE_SUMMARY_CONFIG.pro.currency,
        locale: DEFAULT_LOCALE,
      }),
    },
  }
}
